var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
export class ConnectedStripeCustomerPatientFullSizeDto {
    id;
    createdAt;
    updatedAt;
    connectedStripeAccountId;
    stripeCustomerId;
    userId;
    user;
    connectedStripeAccount;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "stripeCustomerId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "user", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], ConnectedStripeCustomerPatientFullSizeDto.prototype, "connectedStripeAccount", void 0);
//# sourceMappingURL=connected-stripe-customer-patient.full-size.dto.js.map